import React from 'react';
import { Box } from '@medely/ui-kit';
import { PageLayoutContentProps } from './interface';

export const PageLayoutContent = ({ children }: PageLayoutContentProps) => (
  <Box py={3} px={2}>
    {children}
  </Box>
);
